import React from 'react';
import { useTopPerformers } from '../../../hooks/usePartnerData';
import Icon from '../../../components/AppIcon';

const TopPerformers = () => {
  const { performers, loading, error } = useTopPerformers();

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 0
    })?.format(amount);
  };

  if (loading) {
    return (
      <div className="bg-card border border-border rounded-lg p-6 shadow-sm">
        <h3 className="text-lg font-semibold text-card-foreground mb-4">Top Performeurs</h3>
        <div className="space-y-4">
          {[1, 2, 3, 4, 5]?.map(i => (
            <div key={i} className="animate-pulse flex items-center space-x-3">
              <div className="w-8 h-8 bg-muted rounded-full"></div>
              <div className="flex-1">
                <div className="h-4 bg-muted rounded w-3/4 mb-1"></div>
                <div className="h-3 bg-muted rounded w-1/2"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-card border border-border rounded-lg p-6 shadow-sm">
        <h3 className="text-lg font-semibold text-card-foreground mb-4">Top Performeurs</h3>
        <div className="text-center text-muted-foreground py-8">
          <Icon name="AlertCircle" size={32} className="mx-auto mb-2" />
          <p>Erreur de chargement des performeurs</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-sm">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-card-foreground">Top Performeurs</h3>
        <button className="text-sm text-accent hover:text-accent/80 transition-colors">
          Voir tout
        </button>
      </div>

      <div className="space-y-4">
        {performers?.length === 0 ? (
          <div className="text-center text-muted-foreground py-8">
            <Icon name="TrendingUp" size={32} className="mx-auto mb-2" />
            <p>Aucun performeur disponible</p>
          </div>
        ) : (
          performers?.slice(0, 8)?.map((performer, index) => (
            <div key={performer?.id} className="flex items-center justify-between p-3 border border-border rounded-lg hover:bg-muted/50 transition-colors">
              <div className="flex items-center space-x-3">
                <div className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold text-white ${
                  index === 0 ? 'bg-yellow-500' :
                  index === 1 ? 'bg-gray-400' :
                  index === 2 ? 'bg-orange-500': 'bg-accent'
                }`}>
                  {index + 1}
                </div>
                <div>
                  <h4 className="font-medium text-card-foreground">{performer?.name}</h4>
                  <p className="text-sm text-muted-foreground">
                    {performer?.recentCommissions} commissions récentes
                  </p>
                </div>
              </div>

              <div className="text-right">
                <div className="font-semibold text-card-foreground">
                  {formatCurrency(performer?.totalEarnings)}
                </div>
                <div className="flex items-center space-x-1 text-sm text-green-600">
                  <Icon name="TrendingUp" size={12} />
                  <span>+{Math.floor(Math.random() * 20 + 5)}%</span>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default TopPerformers;